/**
 * Tiny helpers shared by Companion pages.
 */
import { format, parseISO } from "date-fns";

export const STATUS_LABELS = {
  scheduled: "Scheduled",
  in_progress: "In Progress",
  on_hold: "On Hold",
  completed: "Completed",
  invoiced: "Invoiced",
};

export const STATUS_COLORS = {
  scheduled: "bg-crest-navy/10 text-crest-navy",
  in_progress: "bg-crest-gold/15 text-amber-800",
  on_hold: "bg-orange-100 text-orange-800",
  completed: "bg-crest-green/15 text-crest-green",
  invoiced: "bg-emerald-100 text-emerald-700",
};

export const PHOTO_LABELS = {
  before: "Before",
  in_progress: "In Progress",
  issue: "Issue / Snag",
  after: "After",
};

export const GALLERY_CATS = [
  { id: "render-insulation", label: "Render & Insulation" },
  { id: "domestic-extensions", label: "Domestic & Extensions" },
  { id: "commercial", label: "Commercial" },
  { id: "landscaping", label: "Landscaping" },
];

export const formatDate = (s, fallback = "—") => {
  if (!s) return fallback;
  try { return format(parseISO(s), "EEE d MMM"); } catch { return s; }
};

export const formatDateTime = (s) => {
  if (!s) return "—";
  try { return format(parseISO(s), "d MMM HH:mm"); } catch { return s; }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const hoursBetween = (startIso, endIso) => {
  if (!startIso || !endIso) return 0;
  return (new Date(endIso) - new Date(startIso)) / 3_600_000;
};
